/* global google */
function zoomControl(controlDiv, map, brandColor) {
  const body = document.querySelector('body');
  const theme = body.getAttribute('js-theme');

  let bgColor;
  if (brandColor === 'endeavour') {
    bgColor = '#304a99';
  } else if (brandColor === 'christalle') {
    bgColor = '#4b2077';
  } else if (brandColor === 'nero') {
    bgColor = '#272425';
  } else if (brandColor === 'pink') {
    bgColor = '#eb008a';
  } else if (brandColor === 'violent-violet') {
    bgColor = '#2a1e4c';
  } else if (brandColor === 'golden-yellow') {
    bgColor = '#ffe500';
  } else if (brandColor === 'black') {
    bgColor = '#000000';
  }

  const controlWrapper = document.createElement('div');
  controlWrapper.className = 'map-zoom-controller';
  /* eslint-disable no-param-reassign */
  controlDiv.style.paddingTop = '24px';
  controlDiv.style.paddingRight = '24px';
  /* eslint-enable no-param-reassign */
  controlWrapper.style.backgroundColor = bgColor;
  controlWrapper.style.cursor = 'pointer';
  controlWrapper.style.width = '48px';
  controlWrapper.style.height = '97px';
  controlDiv.appendChild(controlWrapper);

  // Set CSS for the zoomIn
  const zoomInButton = document.createElement('div');
  zoomInButton.style.width = '48px';
  zoomInButton.style.height = '48px';
  zoomInButton.style.borderBottomStyle = 'solid';
  zoomInButton.style.borderBottomColor = '#EDEEEF';
  zoomInButton.style.borderBottomWidth = '1px';
  zoomInButton.style.backgroundImage = `url(/svg/ic_add-${theme}.svg)`;
  zoomInButton.style.backgroundRepeat = 'no-repeat';
  zoomInButton.style.backgroundPosition = 'center center';
  zoomInButton.style.backgroundSize = '24px 24px';
  controlWrapper.appendChild(zoomInButton);

  // Set CSS for the zoomOut
  const zoomOutButton = document.createElement('div');
  zoomOutButton.style.width = '48px';
  zoomOutButton.style.height = '48px';
  zoomOutButton.style.backgroundImage = `url(/svg/ic_remove-${theme}.svg)`;
  zoomOutButton.style.backgroundRepeat = 'no-repeat';
  zoomOutButton.style.backgroundPosition = 'center center';
  zoomOutButton.style.backgroundSize = '24px 24px';
  controlWrapper.appendChild(zoomOutButton);

  google.maps.event.addDomListener(zoomInButton, 'click', () => {
    map.setZoom(map.getZoom() + 1);
  });

  google.maps.event.addDomListener(zoomOutButton, 'click', () => {
    map.setZoom(map.getZoom() - 1);
  });
}

const mapZoomControl = (map, brandColor) => {
  const zoomControlDiv = document.createElement('div');
  zoomControl(zoomControlDiv, map, brandColor);

  zoomControlDiv.index = 1;
  map.controls[google.maps.ControlPosition.RIGHT_TOP].push(zoomControlDiv);
};

export default mapZoomControl;
